angular.module("accordionAggiornamentoAdv.module")
    .component("accordionIndividualPersonAdv", {
        templateUrl: 'ng/components/accordionAggiornamentoAdv/accordionIndividualPersonAdv/accordionIndividualPersonAdv.view.html',
        bindings: {
            model: '=',
            richiestePostVendita: '=',
            individualsOk: '&',
            individualsNotOk: '&',
            changedSignature: '<'
        },
        controller: AccordionIndividualPersonAdvController,
        controllerAs: 'accordionIndividualPersonAdvCtrl'
    })

function AccordionIndividualPersonAdvController(
    $rootScope,
    $portalService,
    Pf,
    $searchUserService,
    $timeout,
    $modalService,
    validationService,
    $RichiestePostVenditaService,
    $instantService,
    $typeDomainService
) {
    var self = this;

    self.$onInit = function () {
        self.supportModel = {
            loaderRemove: []
        }
        self.$rootScope = $rootScope;
        self.listOfDisabledUser = [];
        self.inPurgatory = [];
        self.mapComuni = $rootScope.comuniMap;
        self.mapComuniNsilSoppressi = $rootScope.mapComuniSoppressi;
        self.isDigital = true;
        self.$portalService = $portalService;
        self.model = self.model.map(function (pf) {
            return Pf.build(pf);
        });
        self.checkOk();
        self.nationsList = $rootScope.nazioniEstere
        self.nationsBirthForeignList = $rootScope.nazioniEstere.filter(x => {
            return x.description != '086' && x.description != '139' && x.description != 'T86'
        })
        getListaEntiRilascio();
    }

    self.$onChanges = function (changed) {

        if (changed.changedSignature && typeof changed.changedSignature.currentValue != 'undefined') {
            self.checkOk();
        }

    }

    self.searchPF = function () {
        self.searching = true;
        self.openSectionUpgradePf = false;
        if (self.userAlreadyAdded(self.searchObj.pfcf.toUpperCase())) {
            return
        }

        self.PFresultsShown = true;
        $searchUserService
            .getCustomerFByNsil(self.searchObj.pfcf.toUpperCase())
            .then(function (pf) {

                if (!pf || !pf.metadata || !pf.metadata.riUserF) {

                    console.log('Ora devi dare la possibilità di censire la nuova persona');
                    var data = {
                        cf: self.searchObj.pfcf.toUpperCase(),
                        prospect: true
                    }
                    self.tempPerson = Pf.build(data);
                } else {

                    //elimino le informazioni sul campo titolare o firmatario se presenti
                    //così da obbligare alla selezione del ruolo relativo della persona cercata
                    pf.metadata.riUserF.validCertificate = pf.validCertificate;
                    pf.metadata.riUserF.titolare.selected = false;
                    pf.metadata.riUserF.firmatario.selected = false;

                    self.tempPerson = Pf.build(pf.metadata.riUserF);
                }

                self.PFresultsShown = true;

                self.documentFromNsil = null;
                self.inPurgatory.push(self.tempPerson.cf);
                var listOfUser = [self.tempPerson];
                //searchOfusersDisabled(listOfUser);

            })
            .catch(function (error) {
                console.log('error', error);
            })
            .finally(function () {
                self.searching = false;

            })

    }

    self.userAlreadyAdded = function (pf, checkNdg) {
        var result = false;
        if (checkNdg) {
            result = self.model && !!self.model.find(function (el) {
                return el.ndg === pf;
            });

        } else {
            result = self.model &&
                !!self.model.find(function (el) {
                    return el.cf && el.cf.toUpperCase() === pf.toUpperCase();
                });

        }
        if (result) {
            $rootScope.$broadcast('addAlert', {
                text: 'PF_ALREADY_ADDED'
            });
            self.cleanUserFound();
        }

        return result;


    }

    self.cleanUserFound = function () {
        self.tempPerson = {};
        self.PFresultsShown = false;
        self.searchObj.pfcf = "";
        self.searchObj.ndg = "";
    }

    self.canAddPfToList = function (pf) {
        var alreadyAdded =
            self.model &&
            self.model.find(function (pff) {
                return pff.cf == pf.cf
            });


        return !alreadyAdded && (self.tempPerson.firmatario.selected ||
            self.tempPerson.titolare.selected ||
            self.tempPerson.garante.selected);
    }

    self.addPfToList = function (pf) {
        var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
        if (!pf.isEstero) {

            self.model.push(Pf.build(pf).setDefaultPfValues(self.nationsList, comuni));

        } else {
            self.model.push(Pf.build(pf));
        }
        self.cleanUserFound();
        self.checkOk();
        var tempUser = [pf]
        searchOfusersDisabled(tempUser, true);
    }

    self.editPf = function (pf) {
        if (!pf.isEstero) {
            var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
            pf = Pf.build(pf).setDefaultPfValues(self.nationsList, comuni);
            pf.sesso = pf.sesso.toLowerCase();
            self.user = pf;
            var fromTable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            pf.cf = pf.cf.toUpperCase();
            self.currentPf = JSON.parse(JSON.stringify(pf));
            //self.currentPf.documento.dataScadenza = self.getEndDate(self.currentPf.documento.dataRilascio);
            console.log('currentPf: ', self.currentPf);

            if (self.isForeignCf(self.currentPf.cf)) {
                self.currentPf.datiNascita.provincia = 'EE';
            }

            self.currentPfCf = self.currentPf.cf;
            $timeout(function () {
                $modalService.openModal('censusPerson');
                $("#footerInstant").css("z-index", "-1");
                $('.financial-leasing__footer').css("z-index", "-1");
            }, 100)
            console.log('currentPf: ', self.currentPf);

            self.enableModal = true;
        } else {
            self.user = pf;
            self.disableButtonAddEstero = true;
            self.enableModalPfEstero = true;
            $timeout(function () {
                $("#footerInstant").css("z-index", "-1");
                $('.financial-leasing__footer').css("z-index", "-1");
                $modalService.openModal("censusPfEstero");
                self.disableButtonAddEstero = false;
            }, 100)

        }
    }

    self.isForeignCf = function (cf) {
        return cf && cf.substr(11, 1) == 'Z';
    }


    self.check = function (el) {
        el.selected = !el.selected;
        self.checkOk();
    }

    self.changed = function (pf) {

        self.enableLoader = true;
        $rootScope.$broadcast("pageLoader", {
            action: "OPEN"
        });

        var index = self.model.findIndex(function (el) {
            return el.cf == pf.cf;
        });
        if (index < 0 && pf.cf) {
            self.model.push(pf);
        } else if (pf.cf) {
            self.model.splice(index, 1, pf);
        }
        self.model.riUserF = self.riUserF;

        if (!pf.isOk) {
            self.enableLoader = false;
            if (pf.isEstero) {
                $modalService.closeModal('censusPfEstero');
                self.enableModalPfEstero = false;
            } else {
                $modalService.closeModal('censusPerson');
            }

            return;
        }


        $RichiestePostVenditaService.updatePersonalActivityPv(self.richiestePostVendita.id, Pf.build(pf))
            .then(function (response) {
                self.enableLoader = false;
                $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE"
                });
                if (response.success) {
                    self.enableModal = false;
                    if (pf.isEstero) {
                        $modalService.closeModal('censusPfEstero');
                        self.enableModalPfEstero = false;
                    } else {
                        $modalService.closeModal('censusPerson');
                    }
                    $("#footerInstant").css("z-index", "2");
                    $('.financial-leasing__footer').css("z-index", "2");
                    jQuery('.mCSB_scrollTools').css("z-index", "2");
                    pf.isOk = true;
                    pf.datiIncompleti = false;
                } else {
                    pf.isOk = false;
                }

                self.checkOk();
                checkIfUserNotRule();
            })
            .catch(function (error) {
                self.checkOk();
                self.enableLoader = false;
                $rootScope.$broadcast("pageLoader", {
                    action: "CLOSE"
                });
                pf.personalDocsComplete = false;
                checkIfUserNotRule();
            })


    }
    self.checkMandato = function () {
        self.richiestePostVendita.metadata.aggiornamentoAdv.adeguataVerifica.mandatoFiduciario = !self.richiestePostVendita.metadata.aggiornamentoAdv.adeguataVerifica.mandatoFiduciario;
        self.checkOk();
    }

    self.checkOk = function () {
        checkAllDataCompleted();
        var tmp = JSON.parse(JSON.stringify(self.model));
        var isOkPf = tmp && tmp
            .every(function (el) {
                return el.isOk === true;
            });
        self.isPresentTitolare = tmp && tmp.some(function (elem) {
            return elem && elem.titolare && elem.titolare.selected === true
        })

        self.isPresentFirmatario = tmp && tmp.some(function (elem) {
            return elem && elem.firmatario && elem.firmatario.selected === true
        })
        var ruleIsSelected = tmp && tmp
            .every(function (element) {
                return element.notRule == false;
            })
        if (ruleIsSelected && isOkPf && ((self.richiestePostVendita.metadata.aggiornamentoAdv.adeguataVerifica.mandatoFiduciario && self.isPresentFirmatario)) && !!!self.listOfDisabledUser.length) {
            self.individualsOk();
            return;
        } else if (((self.isPresentTitolare && self.isPresentFirmatario)) &&
            ruleIsSelected && isOkPf && !!!self.listOfDisabledUser.length) {

            self.individualsOk();
            return;

        } else {

            self.individualsNotOk();
            return;

        }



    }

    self.goBackModal = function (id) {
        $modalService.closeModal(id);
        self.enableModal = false;
        self.enableModalPfEstero = false;
        self.user = Pf.build();
        self.checkOk();
    }


    var searchOfusersDisabled = function (user, fromAddDeleteUser, isDelete) {

        if (fromAddDeleteUser) {
            var elementIsPresent = self.listOfDisabledUser
                .findIndex(function (element) {
                    return element.cf == user[0].cf;
                })
            if (elementIsPresent >= 0 && isDelete) {
                self.listOfDisabledUser.splice(elementIsPresent, 1)

            } else if (elementIsPresent < 0) {
                self.listOfDisabledUser = self.listOfDisabledUser.concat(user
                    .filter(function (element) {
                        return element.deleted == true;
                    }));
            }
        } else {
            self.listOfDisabledUser = self.listOfDisabledUser.concat(
                user.filter(function (element) {
                    if (element) {
                        return element.deleted == true;
                    }

                }));
        }

        if (self.inPurgatory.length >= 2) {
            var oldValue = self.inPurgatory.shift();
            var elementIsAdded = self.model
                .findIndex(function (element) {
                    return element.cf == oldValue;
                })
            if (elementIsAdded < 0) {
                self.listOfDisabledUser = self.listOfDisabledUser
                    .filter(function (element) {
                        return element.cf != oldValue;
                    })
            }
        }

        if (self.listOfDisabledUser.length) {
            self.enableMexUsersDisabled = true;
        } else {
            self.enableMexUsersDisabled = false;
        }
        self.checkOk();
    }

    var checkAllDataCompleted = function () {
        self.model
            .forEach(function (element, index) {
                if (element && element.firmatario && element.firmatario.selected) {
                    if (self.richiestePostVendita.metadata.aggiornamentoAdv.firmaDigitale && !self.richiestePostVendita.metadata.aggiornamentoAdv.firmaDigitaleEsterna) {
                        if ($portalService.isAru()) {
                            if (element.isEstero) {
                                if (element.residenza.provincia == 'EE' || element.residenza.provincia == 'SE') {
                                    element.isOk = !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        !!element.telefono &&
                                        !!element.email &&
                                        element.documentiCaricati &&
                                        checkCongrCogNomeCF(element)

                                } else {
                                    element.isOk = !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.cap &&
                                        (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        !!element.telefono &&
                                        !!element.email &&
                                        element.documentiCaricati &&
                                        checkCongrCogNomeCF(element)

                                }


                            } else if (!element.isEstero && element.cf.substr(11, 1).toUpperCase() == 'Z') {
                                if (element.residenza.provincia == 'EE' || element.residenza.provincia == 'SE') {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        !!element.telefono &&
                                        !!element.email &&
                                        element.documentiCaricati &&
                                        checkCongrCogNomeCF(element)

                                } else {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.cap &&
                                        (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        !!element.telefono &&
                                        !!element.email &&
                                        element.documentiCaricati &&
                                        checkCongrCogNomeCF(element)

                                }

                            } else {
                                if (element.residenza.provincia == 'EE' || element.residenza.provincia == 'SE') {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        !!element.telefono &&
                                        !!element.email &&
                                        element.documentiCaricati &&
                                        checkCongrCogNomeCF(element)

                                } else {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.cap &&
                                        (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        !!element.telefono &&
                                        !!element.email &&
                                        element.documentiCaricati &&
                                        checkCongrCogNomeCF(element)

                                }

                            }


                        } else {
                            if (element.isEstero) {
                                if (element.residenza.provincia == 'EE' || element.residenza.provincia == 'SE') {
                                    element.isOk = !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        checkCongrCogNomeCF(element)

                                } else {
                                    element.isOk = !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        checkCongrCogNomeCF(element)

                                }



                            } else if (!element.isEstero && element.cf.substr(11, 1).toUpperCase() == 'Z') {
                                if (element.residenza.provincia == 'EE' || element.residenza.provincia == 'SE') {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        checkCongrCogNomeCF(element)

                                } else {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.cap &&
                                        (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        checkCongrCogNomeCF(element)

                                }


                            } else {
                                if (element.residenza.provincia == 'EE' || element.residenza.provincia == 'SE') {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        checkCongrCogNomeCF(element)

                                } else {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.cap &&
                                        (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        checkCongrCogNomeCF(element)

                                }

                            }
                        }
                    } else {
                        if ($portalService.isAru()) {
                            if (element.isEstero) {
                                if (element.residenza.provincia == 'EE' || element.residenza.provincia == 'SE') {
                                    element.isOk = !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        element.documentiCaricati &&
                                        checkCongrCogNomeCF(element)

                                } else {
                                    element.isOk = !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.cap &&
                                        (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        element.documentiCaricati &&
                                        checkCongrCogNomeCF(element)

                                }


                            } else if (!element.isEstero && element.cf.substr(11, 1).toUpperCase() == 'Z') {
                                if (element.residenza.provincia == 'EE' || element.residenza.provincia == 'SE') {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        element.documentiCaricati &&
                                        checkCongrCogNomeCF(element)

                                } else {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.cap &&
                                        (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        element.documentiCaricati &&
                                        checkCongrCogNomeCF(element)

                                }

                            } else {
                                if (element.residenza.provincia == 'EE' || element.residenza.provincia == 'SE') {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        element.documentiCaricati &&
                                        checkCongrCogNomeCF(element)

                                } else {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.cap &&
                                        (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        element.documentiCaricati &&
                                        checkCongrCogNomeCF(element)

                                }

                            }


                        } else {
                            if (element.isEstero) {
                                if (element.residenza.provincia == 'EE' || element.residenza.provincia == 'SE') {
                                    element.isOk = !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        checkCongrCogNomeCF(element)

                                } else {
                                    element.isOk = !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.statoEsteso || !!element.documento.statoEsteso.name) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        (!!element.residenza.statoEsteso || !!element.residenza.statoEsteso.name) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        checkCongrCogNomeCF(element)

                                }



                            } else if (!element.isEstero && element.cf.substr(11, 1).toUpperCase() == 'Z') {
                                if (element.residenza.provincia == 'EE' || element.residenza.provincia == 'SE') {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        checkCongrCogNomeCF(element)

                                } else {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        !!element.datiNascita.stato.value &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.cap &&
                                        (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        checkCongrCogNomeCF(element)

                                }


                            } else {
                                if (element.residenza.provincia == 'EE' || element.residenza.provincia == 'SE') {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        checkCongrCogNomeCF(element)

                                } else {
                                    element.isOk = !!element.cf &&
                                        !!element.nome &&
                                        !!element.cognome &&
                                        !!element.sesso &&
                                        !!element.documento &&
                                        !!element.documento.dataRilascio &&
                                        !!element.documento.dataScadenza &&
                                        !!element.documento.enteRilascio.name &&
                                        !!element.documento.numero &&
                                        !!element.documento.provincia &&
                                        !!element.documento.tipo &&
                                        (!!element.documento.luogo || !!element.documento.luogoEsteso.nome) &&
                                        (!!element.datiNascita.comune || !!element.datiNascita.luogoEsteso.nome) &&
                                        !!element.datiNascita.data &&
                                        !!element.datiNascita.provincia &&
                                        !!element.residenza.cap &&
                                        (!!element.residenza.comune || !!element.residenza.luogoEsteso.nome) &&
                                        !!element.residenza.numeroCivico &&
                                        !!element.residenza.provincia &&
                                        !!element.residenza.indirizzo &&
                                        !!element.firmatario.ruolo &&
                                        checkCongrCogNomeCF(element)

                                }

                            }
                        }

                    }
                } else if (element) {
                    element.isOk = controlloIesimoPf(element);

                }
            })
    }

    var controlloIesimoPf = function (pf) {
        if ($portalService.isAru()) {
            if (pf.isEstero) {
                if (pf.residenza.provincia == 'EE' || pf.residenza.provincia == 'SE') {
                    return (
                        !!pf.nome &&
                        !!pf.cognome &&
                        !!pf.sesso &&
                        !!pf.documento &&
                        !!pf.documento.dataRilascio &&
                        !!pf.documento.dataScadenza &&
                        !!pf.documento.enteRilascio.name &&
                        !!pf.documento.numero &&
                        !!pf.documento.provincia &&
                        !!pf.documento.tipo &&
                        (!!pf.documento.statoEsteso || !!pf.documento.statoEsteso.name) &&
                        !!pf.datiNascita.stato.value &&
                        !!pf.datiNascita.data &&
                        !!pf.datiNascita.provincia &&
                        (!!pf.residenza.statoEsteso || !!pf.residenza.statoEsteso.name) &&
                        !!pf.residenza.numeroCivico &&
                        !!pf.residenza.provincia &&
                        !!pf.residenza.indirizzo &&
                        !!pf.titolare &&
                        pf.documentiCaricati
                    )

                } else {
                    return (
                        !!pf.nome &&
                        !!pf.cognome &&
                        !!pf.sesso &&
                        !!pf.documento &&
                        !!pf.documento.dataRilascio &&
                        !!pf.documento.dataScadenza &&
                        !!pf.documento.enteRilascio.name &&
                        !!pf.documento.numero &&
                        !!pf.documento.provincia &&
                        !!pf.documento.tipo &&
                        (!!pf.documento.statoEsteso || !!pf.documento.statoEsteso.name) &&
                        !!pf.datiNascita.stato.value &&
                        !!pf.datiNascita.data &&
                        !!pf.datiNascita.provincia &&
                        !!pf.residenza.cap &&
                        (!!pf.residenza.statoEsteso || !!pf.residenza.statoEsteso.name) &&
                        !!pf.residenza.numeroCivico &&
                        !!pf.residenza.provincia &&
                        !!pf.residenza.indirizzo &&
                        !!pf.titolare &&
                        pf.documentiCaricati
                    )

                }

            } else if (!pf.isEstero && pf.cf.substr(11, 1).toUpperCase() == 'Z') {
                if (pf.residenza.provincia == 'EE' || pf.residenza.provincia == 'SE') {
                    return (
                        !!pf.cf &&
                        !!pf.nome &&
                        !!pf.cognome &&
                        !!pf.sesso &&
                        !!pf.documento &&
                        !!pf.documento.dataRilascio &&
                        !!pf.documento.dataScadenza &&
                        !!pf.documento.enteRilascio.name &&
                        !!pf.documento.numero &&
                        !!pf.documento.provincia &&
                        !!pf.documento.tipo &&
                        (!!pf.documento.luogo || !!pf.documento.luogoEsteso.nome) &&
                        !!pf.datiNascita.stato.value &&
                        !!pf.datiNascita.data &&
                        !!pf.datiNascita.provincia &&
                        !!pf.residenza.numeroCivico &&
                        !!pf.residenza.provincia &&
                        !!pf.residenza.indirizzo &&
                        !!pf.titolare &&
                        pf.documentiCaricati
                    )

                } else {
                    return (
                        !!pf.cf &&
                        !!pf.nome &&
                        !!pf.cognome &&
                        !!pf.sesso &&
                        !!pf.documento &&
                        !!pf.documento.dataRilascio &&
                        !!pf.documento.dataScadenza &&
                        !!pf.documento.enteRilascio.name &&
                        !!pf.documento.numero &&
                        !!pf.documento.provincia &&
                        !!pf.documento.tipo &&
                        (!!pf.documento.luogo || !!pf.documento.luogoEsteso.nome) &&
                        !!pf.datiNascita.stato.value &&
                        !!pf.datiNascita.data &&
                        !!pf.datiNascita.provincia &&
                        !!pf.residenza.cap &&
                        (!!pf.residenza.comune || !!pf.residenza.luogoEsteso.nome) &&
                        !!pf.residenza.numeroCivico &&
                        !!pf.residenza.provincia &&
                        !!pf.residenza.indirizzo &&
                        !!pf.titolare &&
                        pf.documentiCaricati
                    )

                }

            } else {
                if (pf.residenza.provincia == 'EE' || pf.residenza.provincia == 'SE') {
                    return (
                        !!pf.cf &&
                        !!pf.nome &&
                        !!pf.cognome &&
                        !!pf.sesso &&
                        !!pf.documento &&
                        !!pf.documento.dataRilascio &&
                        !!pf.documento.dataScadenza &&
                        !!pf.documento.enteRilascio.name &&
                        !!pf.documento.numero &&
                        !!pf.documento.provincia &&
                        !!pf.documento.tipo &&
                        (!!pf.documento.luogo || !!pf.documento.luogoEsteso.nome) &&
                        (!!pf.datiNascita.comune || !!pf.datiNascita.luogoEsteso.nome) &&
                        !!pf.datiNascita.data &&
                        !!pf.datiNascita.provincia &&
                        !!pf.residenza.numeroCivico &&
                        !!pf.residenza.provincia &&
                        !!pf.residenza.indirizzo &&
                        !!pf.titolare &&
                        pf.documentiCaricati
                    )

                } else {
                    return (
                        !!pf.cf &&
                        !!pf.nome &&
                        !!pf.cognome &&
                        !!pf.sesso &&
                        !!pf.documento &&
                        !!pf.documento.dataRilascio &&
                        !!pf.documento.dataScadenza &&
                        !!pf.documento.enteRilascio.name &&
                        !!pf.documento.numero &&
                        !!pf.documento.provincia &&
                        !!pf.documento.tipo &&
                        (!!pf.documento.luogo || !!pf.documento.luogoEsteso.nome) &&
                        (!!pf.datiNascita.comune || !!pf.datiNascita.luogoEsteso.nome) &&
                        !!pf.datiNascita.data &&
                        !!pf.datiNascita.provincia &&
                        !!pf.residenza.cap &&
                        (!!pf.residenza.comune || !!pf.residenza.luogoEsteso.nome) &&
                        !!pf.residenza.numeroCivico &&
                        !!pf.residenza.provincia &&
                        !!pf.residenza.indirizzo &&
                        !!pf.titolare &&
                        pf.documentiCaricati
                    )
                }

            }

        } else {
            if (pf.isEstero) {
                return (
                    !!pf.nome &&
                    !!pf.cognome &&
                    !!pf.sesso &&
                    !!pf.documento &&
                    !!pf.documento.dataRilascio &&
                    !!pf.documento.dataScadenza &&
                    !!pf.documento.enteRilascio.name &&
                    !!pf.documento.numero &&
                    !!pf.documento.provincia &&
                    !!pf.documento.tipo &&
                    (!!pf.documento.statoEsteso || !!pf.documento.statoEsteso.name) &&
                    !!pf.datiNascita.stato.value &&
                    !!pf.datiNascita.data &&
                    !!pf.datiNascita.provincia &&
                    !!pf.residenza.cap &&
                    (!!pf.residenza.statoEsteso || !!pf.residenza.statoEsteso.name) &&
                    !!pf.residenza.numeroCivico &&
                    !!pf.residenza.provincia &&
                    !!pf.residenza.indirizzo &&
                    !!pf.titolare
                )
            } else if (!pf.isEstero && pf.cf.substr(11, 1).toUpperCase() == 'Z') {
                return (
                    !!pf.cf &&
                    !!pf.nome &&
                    !!pf.cognome &&
                    !!pf.sesso &&
                    !!pf.documento &&
                    !!pf.documento.dataRilascio &&
                    !!pf.documento.dataScadenza &&
                    !!pf.documento.enteRilascio.name &&
                    !!pf.documento.numero &&
                    !!pf.documento.provincia &&
                    !!pf.documento.tipo &&
                    (!!pf.documento.luogo || !!pf.documento.luogoEsteso.nome) &&
                    !!pf.datiNascita.stato.value &&
                    !!pf.datiNascita.data &&
                    !!pf.datiNascita.provincia &&
                    !!pf.residenza.cap &&
                    (!!pf.residenza.comune || !!pf.residenza.luogoEsteso.nome) &&
                    !!pf.residenza.numeroCivico &&
                    !!pf.residenza.provincia &&
                    !!pf.residenza.indirizzo &&
                    !!pf.titolare
                )
            } else {
                return (
                    !!pf.cf &&
                    !!pf.nome &&
                    !!pf.cognome &&
                    !!pf.sesso &&
                    !!pf.documento &&
                    !!pf.documento.dataRilascio &&
                    !!pf.documento.dataScadenza &&
                    !!pf.documento.enteRilascio.name &&
                    !!pf.documento.numero &&
                    !!pf.documento.provincia &&
                    !!pf.documento.tipo &&
                    (!!pf.documento.luogo || !!pf.documento.luogoEsteso.nome) &&
                    (!!pf.datiNascita.comune || !!pf.datiNascita.luogoEsteso.nome) &&
                    !!pf.datiNascita.data &&
                    !!pf.datiNascita.provincia &&
                    !!pf.residenza.cap &&
                    (!!pf.residenza.comune || !!pf.residenza.luogoEsteso.nome) &&
                    !!pf.residenza.numeroCivico &&
                    !!pf.residenza.provincia &&
                    !!pf.residenza.indirizzo &&
                    !!pf.titolare
                )

            }
        }

    }

    var checkIfUserNotRule = function () {

        self.model.forEach(function (element) {
            if (!element.titolare.selected && !element.firmatario.selected && !element.garante.selected) {
                element.notRule = true;
            } else {
                element.notRule = false;
            }
        })
        self.checkOk();
    }

    var checkCongrCogNomeCF = function (element) {
        var codCat;
        var testCongNomeCogCF = false;
        if (element && element.datiNascita && (element.datiNascita.provincia == 'EE' || element.datiNascita.provincia == 'SE') && element.datiNascita.stato.name) {
            codCat = element.datiNascita.stato.value;
        } else if (element && element.datiNascita &&
            element.datiNascita.luogoEsteso &&
            element.datiNascita.luogoEsteso.nome && element.datiNascita.luogoEsteso.sigla != 'SE' && element.datiNascita.luogoEsteso.sigla != 'EE') {
            var comuniCompleti = self.mapComuni.concat(self.mapComuniNsilSoppressi);
            var tempCodCat = comuniCompleti
                .filter(function (comune) {
                    return comune.nome.toUpperCase() == element.datiNascita.luogoEsteso.nome.toUpperCase()
                })[0].codiceCatastale;
            codCat = element.datiNascita.luogoEsteso.codiceCatastale ? element.datiNascita.luogoEsteso.codiceCatastale : tempCodCat;
        }
        if (!codCat) {
            testCongNomeCogCF = false;
        } else {
            testCongNomeCogCF = validationService.checkCfWithFieds(
                element.cf,
                element.nome,
                element.cognome,
                element.datiNascita.data,
                element.sesso,
                codCat
            ).value;

        }
        return testCongNomeCogCF;
    }

    self.removePf = function (pf, index) {
        var input = {
            parentId: self.richiestePostVendita.id,
            idUser: pf.cf

        }
        self.supportModel.loaderRemove[index] = true;
        self.disabledAllRemove = true;
        $instantService.deleteSubjectSelection(input)
            .then(function (response) {
                var index = self.model.findIndex(function (el) {
                    return el.cf === pf.cf
                });
                self.model.splice(index, 1);
                self.checkOk();
                self.supportModel.loaderRemove[index] = false;
                self.disabledAllRemove = false;



            })
            .catch(function (error) {
                $rootScope.$broadcast('addAlert', {
                    text: 'ERROR_GENERIC'
                });
                self.checkOk();
                self.supportModel.loaderRemove[index] = false;
                self.disabledAllRemove = false;
            });



    }

    self.addPfEstero = function () {

        self.user = Pf.build({
            isEstero: true,
            datiNascita: {
                provincia: 'EE',
                stato: {
                    value: null,
                    name: null,
                    description: null
                }
            },
            residenza: {
                provincia: 'EE',
                statoEsteso: {
                    value: null,
                    name: null,
                    description: null
                },
                cap: 99999
            },
            documento: {
                provincia: 'EE',
                tipo: 'CAE',
                statoEsteso: {
                    value: null,
                    name: null,
                    description: null
                }
            }
        });
        self.user.datiNascita.stato = null;
        self.disableButtonAddEstero = true;
        self.openSectionUpgradePf = true;



    }

    self.completaPfEstero = function () {
        self.enableModalPfEstero = true;
        self.user.cf = validationService.createCf(self.user.nome, self.user.cognome, self.user.datiNascita.data, self.user.sesso, self.user.datiNascita.stato.value);
        $timeout(function () {
            $("#footerInstant").css("z-index", "-1");
            $('.financial-leasing__footer').css("z-index", "-1");
            $modalService.openModal("censusPfEstero");
            self.disableButtonAddEstero = false;
            self.openSectionUpgradePf = false;
        }, 100)

    }

    self.setDate = function (name, value) {
        self.user.datiNascita.data = value;
    }

    var getListaEntiRilascio = function () {
        $typeDomainService
            .getDomainSet("RI_DROPDOWN_DOMAINS", "AUTHORITY_TYPE")
            .then(function (response) {
                self.listaEntiRilascio = response.domainList;
            });
    }
}